<template>
  <div class="col-12 relative grey-bg">
    <template v-if="routeMatchesComponent()">
      <CategoryHeader :reference="route.meta.reference" :icon="route.meta.icon" />
      <div v-if="user.helloId && !helloDisabled" class="mx3 p2 my2 flex flex-auto pointer action" @click="goToHello()">
        <span class="h5n semi-bold flex items-center">{{ getReferencelabel('MY_CHATS') }}</span>
        <i class="icon-angle-right-icon action-arrow flex flex-auto justify-end"></i>
      </div>
      <ActionButton v-for="(action, actionIndex) in items" :key="actionIndex" :reference="action.reference" :pathname="action.pathName" :path="action.path" />
    </template>
    <router-view v-else />
  </div>
</template>

<script>
import { computed, getCurrentInstance } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import ActionButton from '@/components/elements/ActionButton';
import CategoryHeader from '@/components/common/CategoryHeader';
import { getReferencelabel, menuHandler, routeIsCurrentComponent, goToHello } from '@/mixins/utils';

export default {
  components: {
    ActionButton,
    CategoryHeader
  },
  setup () {
    const store = useStore();

    const route = useRoute();
    const routeMatchesComponent = () => routeIsCurrentComponent(route.name, getCurrentInstance());

    const user = computed(() => store.state.user);

    const items = computed(() => menuHandler(route.name));

    const helloDisabled = computed(() => store.getters.getSiteConfiguration('disabled_features').includes('/:locale?/hello'));

    return { items, route, getReferencelabel, helloDisabled, routeMatchesComponent, user, goToHello };
  }
};
</script>

<style lang="scss" scoped>

.action {
  border: 2px solid white;
  border-radius: 0px;
  background: white;
}

.action:hover {
  border-color: white;
  background: #00a6c6;
  color: white;
}

.action:active {
  border-color: white;
  background: #20bcdc;
  color: white;
}

.action:hover > .action-arrow  {
  color:white;
}

.action-arrow {
  font-size: 30px;
  color:red;
}

</style>
